export default __webpack_public_path__ + "eb09fd6026305655b270cd9551b8d118.png";